export function wrap<T>(items: T | T[]): T[] {
    return Array.isArray(items) ? items : [items]
}
